"use client";

import Script from "next/script";
import "../styles/klaro-custom.css";

export default function CookieConsent() {
  return (
    <>
      <Script 
        src="/js/klaro-config.js" 
        strategy="beforeInteractive"
        id="klaro-config"
      />
      <Script 
        src="/js/vendor/klaro.js" 
        strategy="afterInteractive"
        data-config="klaroConfig"
        id="klaro-script"
      />
    </>
  );
}